export default __webpack_public_path__ + "static/media/coinMan.b667b91c.png";